/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import Button from '../elements/Button';

import {
  ORG_NAME,
  ORG_TAGLINE,
  ORG_ADDRESS_FULL,
  ORG_LOCALE,
  ORG_EMAIL,
  ORG_CHARTER_NUMBER,
  ORG_FOUNDED_LABEL,
} from '../constants';

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Programs', href: '/programs' },
  { label: 'Team', href: '/team' },
  { label: 'Get Involved', href: '/get-involved' },
  { label: 'Donate', href: '/donate' },
];

const pillars = [
  'Artistic Instruction',
  'Mentorship & Guidance',
  'Personal Development',
];

export default function Footer() {
  return (
    <footer className="bg-theme-blue text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand & Description */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <p className="text-3xl font-serif font-bold leading-tight">
                Balance Point
                <span className="block text-theme-gold text-base font-sans font-medium tracking-widest uppercase mt-1">
                  Studios
                </span>
              </p>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              {ORG_TAGLINE}
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Ohio Nonprofit Charter #{ORG_CHARTER_NUMBER}
              <br />
              Founded {ORG_FOUNDED_LABEL}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-theme-gold uppercase tracking-wider text-sm">Explore</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Button
                    href={link.href}
                    type="link"
                    className="text-gray-300 hover:text-white hover:pl-2 transition-all duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          {/* Pillars */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-theme-gold uppercase tracking-wider text-sm">Our Pillars</h3>
            <ul className="space-y-3">
              {pillars.map((pillar) => (
                <li key={pillar} className="text-gray-300 flex items-center gap-2">
                  <svg className="w-4 h-4 text-theme-gold flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {pillar}
                </li>
              ))}
            </ul>
            {/* TODO: add socials when handles confirmed */}
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-theme-gold uppercase tracking-wider text-sm">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-theme-gold mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div>
                  <p className="text-gray-400 text-sm">Email</p>
                  <a href={`mailto:${ORG_EMAIL}`} className="text-white hover:text-theme-gold transition-colors cursor-pointer">
                    {ORG_EMAIL}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <svg className="w-5 h-5 text-theme-gold mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-gray-400 text-sm">Address</p>
                  <p className="text-white text-sm leading-relaxed">
                    {ORG_ADDRESS_FULL}
                    <br />
                    <span className="text-gray-400">{ORG_LOCALE}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} {ORG_NAME}. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="/privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="/terms" className="hover:text-white transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
